import { GitFileTree } from '../models/git-worker.model';
import { traverseTree } from '../util/traverse-tree';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSReadDirAction extends WorkerAction {
  type: FSAction.ReadDir;
  params?: {
    path?: string;
    excludeChildren?: boolean;
    countChildren?: boolean;
  };
}

export async function FSReadDirActionFn({
  params,
  util,
}: WorkerFnParams<FSReadDirAction>): Promise<{ numberOfFiles?: number; tree: GitFileTree }> {
  let { path } = params || {};

  if (!path) {
    path = './';
  }

  const tree = util.readFileTree(path, { excludeChildren: params?.excludeChildren });
  let numberOfFiles: number | undefined;

  if (params?.countChildren) {
    numberOfFiles = 0;
    traverseTree(tree, (item) => {
      if (item.type === 'file') {
        (numberOfFiles as number)++;
      }
    });
  }

  return { numberOfFiles, tree };
}
